controllers.controller('VerificationSumsubController', [
    '$scope', '$state', '$ionicLoading', 'LocaleService', 'constants', 'ExternalScriptLoader', 'API', 'ErrorService',
    function ($scope, $state, $ionicLoading, LocaleService, Const, ExternalScriptLoader, API, ErrorService) {

        var API_URL = "https://api.sumsub.com/idensic/static/sumsub-kyc.js";

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });


        var sumsub;
        var loader = new ExternalScriptLoader();

        loader.load(API_URL)
            .then(init)
            .catch(function (err) {
                console.warn(err);
            });

        function init() {
            $ionicLoading.show();
            return API.initializeVerification({provider: "sumsub"})
                .then(checkResponse)
                .then(function (response) {
                    $ionicLoading.hide();
                    initSdk(response.accessToken, response.externalUserId);
                })
        }

        function initSdk(accessToken, externalUserId) {
            sumsub = idensic.init(
                '#idensic',
                {
                    clientId: Const['verificationProviderOptions'].clientId,
                    accessToken: accessToken,
                    externalUserId: externalUserId
                },
                function (messageType, payload) {
                    console.log('message:', messageType, payload)
                }
            )
        }


        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'VerificationSumsubController',
                    type: Const.error.type.VALIDATION,
                    code: data.code,
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }


        $scope.$on('$ionicView.beforeEnter', function () {
            if ($scope.user && !$scope.user.tnc && Const['tncPopup']) {
                return $state.go('tnc', {cache: false});
            }
            if ($scope.user) {
                switch ($scope.user.registrationState) {
                    case Const.userState.initial:
                        return $state.go('signupPersonalProfile', {cache: false});
                    case Const.userState.personal:
                        return $state.go('signupQuestionnaire', {cache: false});
                }
            }
        });

    }]);
